// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-68fb82ec] .properties-multiselect .form-search-multiselect__options-group,[data-v-68fb82ec] .properties-multiselect .form-search-multiselect__selected-options-group{max-height:150px !important}", ""]);
// Exports
module.exports = exports;
